import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import { Container } from '../../components/Container';
import { FacebookIcon } from '../../components/FacebookIcon';
import {
  Footer,
  FooterLink,
  FooterLinks,
  FooterTitle,
  FooterWrapper
} from '../../components/Footer';
import { SocialServiceIconType } from '../../components/Icon';
import { InstagramIcon } from '../../components/InstagramIcon';
import { LinkedInIcon } from '../../components/LinkedInIcon';
import { IDefaultProps, IDefaultPropsWithData } from '../../IDefaultProps';
import { Query } from '../../types/graphql-types';

const Content = ({ data }: IDefaultPropsWithData) => {
  return (
    <>
      <Footer>
        <Container>
          <FooterWrapper>
            <FooterLinks>
              {data.allContentfulSocialService &&
                data.allContentfulSocialService.edges &&
                data.allContentfulSocialService.edges.map(edge => {
                  if (
                    !edge ||
                    !edge.node ||
                    !edge.node.name ||
                    !edge.node.url
                  ) {
                    return null;
                  }
                  return (
                    <FooterLink key={edge.node.id} href={edge.node.url}>
                      {edge.node.icon === SocialServiceIconType.Instagram && (
                        <InstagramIcon />
                      )}
                      {edge.node.icon === SocialServiceIconType.Facebook && (
                        <FacebookIcon />
                      )}
                      {edge.node.icon === SocialServiceIconType.LinkedIn && (
                        <LinkedInIcon />
                      )}
                      {edge.node.name}
                    </FooterLink>
                  );
                })}
            </FooterLinks>
            {data.contentfulCompanyInfo &&
              data.contentfulCompanyInfo.longName && (
                <FooterTitle>{data.contentfulCompanyInfo.longName}</FooterTitle>
              )}
          </FooterWrapper>
        </Container>
      </Footer>
    </>
  );
};

export const FooterLayout = (props: IDefaultProps) => {
  const data: Query = useStaticQuery(graphql`
    query {
      allContentfulSocialService(
        filter: { node_locale: { eq: "en-US" } }
        sort: { fields: name, order: DESC }
      ) {
        edges {
          node {
            id
            name
            url
            icon
          }
        }
      }
      contentfulCompanyInfo(node_locale: { eq: "en-US" }) {
        longName
      }
    }
  `);

  return <Content data={data} {...props} />;
};
